import { render, staticRenderFns } from "./reserveItems.vue?vue&type=template&id=84036b24&scoped=true&"
import script from "./reserveItems.vue?vue&type=script&lang=js&"
export * from "./reserveItems.vue?vue&type=script&lang=js&"
import style0 from "./reserveItems.vue?vue&type=style&index=0&id=84036b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84036b24",
  null
  
)

export default component.exports